<template>
  <layout>
    <page-header
      :header="$t('orders.pay_order')"
      :header-small="order && order.invoice_number"
    />
    <div ref="content" class="content">
      <b-row>
        <b-col sm>
          <b-card
            ref="orderSummary"
            :title="order ? order.description : $t('general.loading')"
          >
            <order-items v-if="order" :order="order" class="mb-4" />
            <order-details v-if="order" :order="order" />
          </b-card>
        </b-col>
        <b-col sm>
          <payment-form-wrapper
            v-if="order"
            :order="order"
            :allowed-methods="allowedMethods"
            @methodChanged="onMethodChange"
            @paid="onPay"
          />
        </b-col>
      </b-row>
    </div>
  </layout>
</template>

<script>
import OrdersApi from './Api'
import OrderItems from '../../../console/src/orders/OrderItems'
import OrderDetails from '../../../console/src/orders/OrderDetails'
import PaymentFormWrapper from './PaymentFormWrapper'

export default {
  name: 'OrderPay',
  components: {
    PaymentFormWrapper,
    OrderItems,
    OrderDetails,
  },
  data: () => ({
    order: null,
    allowedMethods: ['card'],
  }),

  mounted() {
    this.loadOrder()
  },
  methods: {
    loadOrder() {
      this.$uiBlocker(
        new OrdersApi().find(this.$route.params.id).then(result => {
          this.order = result.data
          this.allowedMethods = result.allowed_methods
        }),
        this.$refs.content,
      )
    },
    onMethodChange(method) {
      this.$uiBlocker(
        new OrdersApi().calculate(this.order, { method }).then(result => {
          this.order = result.data
        }),
        this.$refs.orderSummary,
      )
    },
    onPay() {
      this.loadOrder()
    },
  },
}
</script>
